// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__qRpC5"};